import { Component, Input } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { marked } from "marked";
import { NzModalService } from "ng-zorro-antd/modal";

@Component({
    selector: "app-rag-result-visualizer",
    templateUrl: "./rag-result-visualizer.component.html",
    styleUrls: ["./rag-result-visualizer.component.less"],
    standalone: false
})
export class RagResultVisualizerComponent {
  @Input() messageContent: null | any = null;
  html_result: SafeHtml = "";
  chunks: any[] = [];

  constructor(
    private sanitizer: DomSanitizer,
    private modalService: NzModalService
  ) {}

  ngOnInit() {
    console.log("ngOnInit", this.messageContent);
    this.chunks = this.messageContent["reference"]["chunks"];
    console.log("chunks", this.chunks);
    this.parse_with_citations();
  }
  getHtml = marked.parse;

  get uniqueChunks() {
    const seen = new Set();
    return this.chunks.filter((chunk) => {
      if (seen.has(chunk.document_id)) return false;
      seen.add(chunk.document_id);
      return true;
    });
  }

  async parse_with_citations() {
    console.log("parsing with citations");
    let html_string = await marked.parse(this.messageContent["answer"]);
    const regex = /\[ID:(\d+)\]/g;

    const replacer: (match: string, idString: string) => string = (
      match,
      idString
    ) => {
      const index = parseInt(idString, 10); // Convert the ID string to a number

      // Check if the index is valid and exists in the chunks array
      console.log(this.chunks);
      console.log(index, match, idString);

      if (index >= 0 && index < this.chunks.length) {
        const chunk = this.chunks[index];
        let chunkName = chunk["document_name"];
        console.log(chunk["doc_type"]);
        // Return the HTML for the tooltip.
        // return `<span nz-tooltip nzTooltipTitle="${chunkName}">ayo<span nz-icon nzType="info-circle" nzTheme="outline"></span></span>`;
        if (chunk["doc_type"] == "image") {
          let image_url = `https://ragflow.substrata.s-cube.com/v1/document/image/${chunk["image_id"]}`;
          return `<div>
            <img src="${image_url}" alt="${chunkName}"> 
          </div>`;
        } else {
          return `<span class="custom-tooltip">
          <span class="custom-tooltip__icon" aria-label="Info">&#9432;</span>
          <span class="custom-tooltip__text" role="tooltip">${chunkName}</span>
          </span>`;
        }
      } else {
        // If the ID is invalid (e.g., [ID:99] but array only has 10 items),
        // return empty syting
        return "";
      }
    };
    // this.sanitizer.
    this.html_result = this.sanitizer.bypassSecurityTrustHtml(
      html_string.replace(regex, replacer)
    );

    console.log(this.html_result);
  }

  getFileExtension(fileName: string): string {
    const parts = fileName.split(".");
    return parts.length > 1 ? parts[parts.length - 1] : "";
  }

  openDocumentModal(chunk: any) {
    const extension = this.getFileExtension(chunk.document_name);
    const documentUrl = `https://ragflow.substrata.s-cube.com/document/${chunk.document_id}?ext=${extension}&prefix=document`;

    console.log("Opening document:", documentUrl);

    import("./document-viewer-modal/document-viewer-modal.component").then(
      (m) => {
        const modal = this.modalService.create({
          nzTitle: chunk.document_name,
          nzContent: m.DocumentViewerModalComponent,
          nzData: {
            documentUrl: documentUrl,
            documentName: chunk.document_name,
            extension: extension,
          },
          nzFooter: null,
          nzWidth: "90vw",
          nzStyle: { top: "20px" },
          nzBodyStyle: { height: "80vh", padding: "0" },
        });
      }
    );
  }
}
